module.exports = __webpack_public_path__ + "media/images/edools_logo_color-f2e35ebfdf79e0f2511bbe9ad6c95ede.png";